// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.patient-events-viewer {}

.patient-events-viewer .patient-events-header {
	padding: 16px;
	font-size: 21px;
	position: relative;
	font-weight: bold;
	background: #f9f9f9;
	border-bottom: solid 1px #b2b2b2;
}

.patient-events-viewer .patient-events-header .subheader {
	font-size: 15px;
	font-weight: normal;
	color: #555;
	padding-top: 5px;
}

.patient-events-viewer .patient-events-header .reconcile-button {
	position: absolute;
	top: 21px;
	right: 16px;
	border: none;
	padding: 0;
	color: #0C509B;
	font-size: 17px;
	cursor: pointer;
	background: none;
}

.patient-events-viewer .patient-events-switcher {}

.patient-events-viewer .patient-events-switcher .current-display-option {
	display: block;
	padding: 16px;
	font-size: 17px;
	font-weight: bold;
}

.patient-events-viewer .patient-events-switcher .variation-selector {
	display: block;
	padding-left: 16px;
	padding-right: 16px;
}

.patient-events-viewer .patient-events-switcher .variation-selector select {
	width: 100%;
	font-size: 17px;
	background: #fff;
	margin-top: 16px;
}

.patient-events-viewer .no-events-message {
	padding: 16px 16px 0 16px;
}

.patient-events-viewer .category {
	padding-top: 16px;
	padding-bottom: 16px;
	margin-left: 16px;
	margin-right: 16px;
	border-bottom: solid 1px #ddd;
}

.patient-events-viewer .category .category-header {
	font-size: 15px;
	padding-bottom: 16px;
	text-transform: uppercase;
	color: #555;
}

.patient-events-viewer .category .category-event {
	padding-top: 8px;
	position: relative;
}

.patient-events-viewer .category .category-event .category-event-content {
	border-bottom: solid 1px #ececec;
	padding-bottom: 8px;
}

.patient-events-viewer .category .category-event .category-event-content.pad-left {
	margin-left: 32px;
}

.patient-events-viewer .category .category-event .category-event-checkbox {
	position: absolute;
	left: 0;
	top: 12px;
}

.patient-events-viewer .category .category-event .flag-icon {
	position: absolute;
	left: 0;
	top: 12px;
}

.patient-events-viewer .category .category-event .flag-icon .fa {
	color: #d6bb28;
	font-size: 15px;
}

.patient-events-viewer .category .category-event .flag-icon.active {
	cursor: pointer;
}

.patient-events-viewer .category .category-event .event-name {
	font-size: 14px;
	position: relative;
	display: block;
	padding-right: 20px;
}

.patient-events-viewer .category .category-event .display-property {
	font-size: 12px;
	color: #555;
}

.patient-events-viewer .category .category-event .annotation {
	display: block;
	padding-left: 15px;
	position: relative;
}

.patient-events-viewer .category .category-event .annotation .fa-edit {
	position: absolute;
	left: 0;
	top: 4px;
	font-size: 12px;
	color: #555;
}

.patient-events-viewer .category .category-event .annotation.active:hover .fa-edit {
	color: #000;
}

.patient-events-viewer .category .category-event .annotation input {
	width: 300px;
	outline: none;
	font-family: Arial;
	padding: 0 0 0 3px;
	height: 18px;
	line-height: 18px;
	border: 1px solid #ddd;
	border-radius: 2px;
	margin-bottom: 3px;
	font-size: 12px;
}

.patient-events-viewer .category .category-event .annotation input.inactive {
	background: #FFF;
	border: 1px solid #FFF;
	margin-bottom: 0;
	cursor: default;
}

.patient-events-viewer .category .category-event .annotation.active input.inactive {
	cursor: pointer;
}

.patient-events-viewer .category .category-event .annotation button {
	height: 23px;
	line-height: 17px;
	font-weight: bold;
	font-size: 11px;
	padding: 4px;
	margin: 0;
	background: #4483C8;
	border: none;
	border-radius: 5px;
	color: #FFF;
	cursor: pointer;
}

.patient-events-viewer .category .category-event.inactive {
	color: #999;
}

.patient-events-viewer .category .category-event:last-child .category-event-content {
	border-bottom: none;
}

.patient-events-viewer .category .category-event .event-name {
	font-size: 15px;
}

.patient-events-viewer .reconcile-save {
	margin: 16px;
}

.patient-events-viewer .reconcile-save .save-button {
	width: 100%;
	text-align: center;
	padding: 8px;
	color: #FFF;
	font-size: 17px;
	background: #4483C8;
	border: none;
	border-radius: 5px;
	color: #FFF;
	cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/widgets/MyDataHelps/Views/PatientEventsViewer.css"],"names":[],"mappings":"AAAA,wBAAwB;;AAExB;CACC,aAAa;CACb,eAAe;CACf,kBAAkB;CAClB,iBAAiB;CACjB,mBAAmB;CACnB,gCAAgC;AACjC;;AAEA;CACC,eAAe;CACf,mBAAmB;CACnB,WAAW;CACX,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,WAAW;CACX,YAAY;CACZ,UAAU;CACV,cAAc;CACd,eAAe;CACf,eAAe;CACf,gBAAgB;AACjB;;AAEA,iDAAiD;;AAEjD;CACC,cAAc;CACd,aAAa;CACb,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,cAAc;CACd,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,iBAAiB;CACjB,oBAAoB;CACpB,iBAAiB;CACjB,kBAAkB;CAClB,6BAA6B;AAC9B;;AAEA;CACC,eAAe;CACf,oBAAoB;CACpB,yBAAyB;CACzB,WAAW;AACZ;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,gCAAgC;CAChC,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,SAAS;AACV;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,SAAS;AACV;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;CACf,kBAAkB;CAClB,cAAc;CACd,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,WAAW;AACZ;;AAEA;CACC,cAAc;CACd,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,OAAO;CACP,QAAQ;CACR,eAAe;CACf,WAAW;AACZ;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,YAAY;CACZ,aAAa;CACb,kBAAkB;CAClB,kBAAkB;CAClB,YAAY;CACZ,iBAAiB;CACjB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;CAClB,eAAe;AAChB;;AAEA;CACC,gBAAgB;CAChB,sBAAsB;CACtB,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,YAAY;CACZ,iBAAiB;CACjB,iBAAiB;CACjB,eAAe;CACf,YAAY;CACZ,SAAS;CACT,mBAAmB;CACnB,YAAY;CACZ,kBAAkB;CAClB,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,YAAY;CACZ,WAAW;CACX,eAAe;CACf,mBAAmB;CACnB,YAAY;CACZ,kBAAkB;CAClB,WAAW;CACX,eAAe;AAChB","sourcesContent":[".patient-events-viewer {}\n\n.patient-events-viewer .patient-events-header {\n\tpadding: 16px;\n\tfont-size: 21px;\n\tposition: relative;\n\tfont-weight: bold;\n\tbackground: #f9f9f9;\n\tborder-bottom: solid 1px #b2b2b2;\n}\n\n.patient-events-viewer .patient-events-header .subheader {\n\tfont-size: 15px;\n\tfont-weight: normal;\n\tcolor: #555;\n\tpadding-top: 5px;\n}\n\n.patient-events-viewer .patient-events-header .reconcile-button {\n\tposition: absolute;\n\ttop: 21px;\n\tright: 16px;\n\tborder: none;\n\tpadding: 0;\n\tcolor: #0C509B;\n\tfont-size: 17px;\n\tcursor: pointer;\n\tbackground: none;\n}\n\n.patient-events-viewer .patient-events-switcher {}\n\n.patient-events-viewer .patient-events-switcher .current-display-option {\n\tdisplay: block;\n\tpadding: 16px;\n\tfont-size: 17px;\n\tfont-weight: bold;\n}\n\n.patient-events-viewer .patient-events-switcher .variation-selector {\n\tdisplay: block;\n\tpadding-left: 16px;\n\tpadding-right: 16px;\n}\n\n.patient-events-viewer .patient-events-switcher .variation-selector select {\n\twidth: 100%;\n\tfont-size: 17px;\n\tbackground: #fff;\n\tmargin-top: 16px;\n}\n\n.patient-events-viewer .no-events-message {\n\tpadding: 16px 16px 0 16px;\n}\n\n.patient-events-viewer .category {\n\tpadding-top: 16px;\n\tpadding-bottom: 16px;\n\tmargin-left: 16px;\n\tmargin-right: 16px;\n\tborder-bottom: solid 1px #ddd;\n}\n\n.patient-events-viewer .category .category-header {\n\tfont-size: 15px;\n\tpadding-bottom: 16px;\n\ttext-transform: uppercase;\n\tcolor: #555;\n}\n\n.patient-events-viewer .category .category-event {\n\tpadding-top: 8px;\n\tposition: relative;\n}\n\n.patient-events-viewer .category .category-event .category-event-content {\n\tborder-bottom: solid 1px #ececec;\n\tpadding-bottom: 8px;\n}\n\n.patient-events-viewer .category .category-event .category-event-content.pad-left {\n\tmargin-left: 32px;\n}\n\n.patient-events-viewer .category .category-event .category-event-checkbox {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 12px;\n}\n\n.patient-events-viewer .category .category-event .flag-icon {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 12px;\n}\n\n.patient-events-viewer .category .category-event .flag-icon .fa {\n\tcolor: #d6bb28;\n\tfont-size: 15px;\n}\n\n.patient-events-viewer .category .category-event .flag-icon.active {\n\tcursor: pointer;\n}\n\n.patient-events-viewer .category .category-event .event-name {\n\tfont-size: 14px;\n\tposition: relative;\n\tdisplay: block;\n\tpadding-right: 20px;\n}\n\n.patient-events-viewer .category .category-event .display-property {\n\tfont-size: 12px;\n\tcolor: #555;\n}\n\n.patient-events-viewer .category .category-event .annotation {\n\tdisplay: block;\n\tpadding-left: 15px;\n\tposition: relative;\n}\n\n.patient-events-viewer .category .category-event .annotation .fa-edit {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 4px;\n\tfont-size: 12px;\n\tcolor: #555;\n}\n\n.patient-events-viewer .category .category-event .annotation.active:hover .fa-edit {\n\tcolor: #000;\n}\n\n.patient-events-viewer .category .category-event .annotation input {\n\twidth: 300px;\n\toutline: none;\n\tfont-family: Arial;\n\tpadding: 0 0 0 3px;\n\theight: 18px;\n\tline-height: 18px;\n\tborder: 1px solid #ddd;\n\tborder-radius: 2px;\n\tmargin-bottom: 3px;\n\tfont-size: 12px;\n}\n\n.patient-events-viewer .category .category-event .annotation input.inactive {\n\tbackground: #FFF;\n\tborder: 1px solid #FFF;\n\tmargin-bottom: 0;\n\tcursor: default;\n}\n\n.patient-events-viewer .category .category-event .annotation.active input.inactive {\n\tcursor: pointer;\n}\n\n.patient-events-viewer .category .category-event .annotation button {\n\theight: 23px;\n\tline-height: 17px;\n\tfont-weight: bold;\n\tfont-size: 11px;\n\tpadding: 4px;\n\tmargin: 0;\n\tbackground: #4483C8;\n\tborder: none;\n\tborder-radius: 5px;\n\tcolor: #FFF;\n\tcursor: pointer;\n}\n\n.patient-events-viewer .category .category-event.inactive {\n\tcolor: #999;\n}\n\n.patient-events-viewer .category .category-event:last-child .category-event-content {\n\tborder-bottom: none;\n}\n\n.patient-events-viewer .category .category-event .event-name {\n\tfont-size: 15px;\n}\n\n.patient-events-viewer .reconcile-save {\n\tmargin: 16px;\n}\n\n.patient-events-viewer .reconcile-save .save-button {\n\twidth: 100%;\n\ttext-align: center;\n\tpadding: 8px;\n\tcolor: #FFF;\n\tfont-size: 17px;\n\tbackground: #4483C8;\n\tborder: none;\n\tborder-radius: 5px;\n\tcolor: #FFF;\n\tcursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
